<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2">
    <input type="checkbox" id="autoDeletionEnabled" formControlName="autoDeletionEnabled" />
    <label class="ps-1" for="autoDeletionEnabled">
      {{ 'Settings::AutoDeletionEnabled' | abpLocalization }}
    </label>
  </div>
  <div class="form-group mt-3">
    <span class="row-container">
      <label for="autoDeletionOption" class="col-form-label pb-1 me-1">
        {{ 'Settings::AutomaticallyDeleteConversations' | abpLocalization }}
      </label>
      <input
        type="number"
        min="1"
        [max]="autoDeletionOptionMaxValue"
        class="form-control form-control-sm"
        id="autoDeletionOption"
        formControlName="autoDeletionOption"
        style="max-width: 80px" />
    </span>
  </div>
  <div class="form-group mt-3">
    <label for="deleteType">{{ 'Settings::DeletionScope' | abpLocalization }}</label>
    <ca-select formControlName="deletionScopeType" [disabled]="autoDeletionDisabled ? true : false">
      <ca-option *ngFor="let option of deletionScopes" [value]="option.code">
        {{ 'GenericLookup::' + option.code | abpLocalization }}
      </ca-option>
    </ca-select>
  </div>
  <div *ngIf="callRecorderEnabled">
    <small class="form-text text-muted">
      {{ 'Settings::Retention.Settings.Description' | abpLocalization }}
    </small>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
